import type { SVGAttributes, ReactNode } from 'react'

export interface IconProps extends SVGAttributes<SVGSVGElement> {
  size?: number | string
  strokeWidth?: number | string
  color?: string
}

export function createIcon(
  displayName: string,
  renderPaths: (props: { strokeWidth: number | string }) => ReactNode,
) {
  function Icon({
    size = 24,
    strokeWidth = 2,
    color = 'currentColor',
    className,
    style,
    ...rest
  }: IconProps) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        style={style}
        {...rest}
      >
        {renderPaths({ strokeWidth })}
      </svg>
    )
  }

  Icon.displayName = displayName
  return Icon
}
